import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Link, useParams } from "react-router-dom"

import { selectScopedByClient } from "../../stores/appSlice"
import { fetchFacility, selectFacility } from "./facilitiesSlice"

export default function FacilityNav({ activeTab, scopedByFacility = false }) {
    const dispatch = useDispatch()
    const { clientId, facilityId } = useParams()
    const facility = useSelector(selectFacility)
    const scopedByClient = useSelector(selectScopedByClient)

    // Fetch the facility we need for breadcrumb
    // TODO: we may be able to simply swap this out for the use selector based
    // on how we decide to finally load in the records from other components.
    useEffect(() => {
        if (facilityId) {
            dispatch(fetchFacility(facilityId))
        }
    }, [dispatch, facilityId])

    const formatRoute = (newRoute) => {
        if (clientId) {
            if (facilityId && scopedByFacility) {
                return `/clients/${clientId}/facilities/${facilityId}${newRoute}`
            } else {
                return `/clients/${clientId}/facilities${newRoute}`
            }
        } else if (facilityId) {
            return `/facilities/${facilityId}${newRoute}`
        }

        return `/facilities${newRoute || ""}`
    }

    // If we are scoped by a client, we are looking at an end-user's view.
    // If we are not scoped by a client, we are looking at an admin's view.
    const renderHeader = () => {
        if (scopedByClient) {
            return scopedByFacility ? renderRecordHeader() : renderIndexHeader()
        }

        // Admin - Not scoped by client here
        return (
            <>
                <h2>Facilities</h2>
                <ul className="header-tab-nav" role="navigation">
                    <li>
                        <Link to={() => formatRoute("/")}>
                            <button type="link" className={`${activeTab === "list" ? "selected" : ""}`}>
                                All Facilities
                            </button>
                        </Link>
                    </li>
                </ul>
            </>
        )
    }

    const renderRecordHeader = () => {
        return (
            <>
                <h2>
                    <Link to={() => `/clients/${clientId}/divisions/${facility.division_id}/dashboard`}>{facility.division_name} &gt; </Link>
                    {`${facility.name}`}
                </h2>
                <ul className="header-tab-nav" role="navigation">
                    <li>
                       <Link to={() => formatRoute("/dashboard")}>
                           <button type="link" className={`${activeTab === "dashboard" ? "selected" : ""}`}>
                               Dashboard
                           </button>
                       </Link>
                    </li>

                    <li>
                        <Link to={() => formatRoute("/documents")}>
                            <button type="link" className={`${activeTab === "documents" ? "selected" : ""}`}>
                                Documents
                            </button>
                        </Link>
                    </li>

                    <li>
                        <Link to={() => formatRoute("/billable_accounts")}>
                            <button type="link" className={`${activeTab === "billable_accounts" ? "selected" : ""}`}>
                                Facility's Billable Accounts
                            </button>
                        </Link>
                    </li>

                    <li>
                        <Link to={() => formatRoute("/supply_accounts")}>
                            <button type="link" className={`${activeTab === "supply_accounts" ? "selected" : ""}`}>
                                Facility's Supply Accounts
                            </button>
                        </Link>
                    </li>
                </ul>
            </>
        )
    }

    const renderIndexHeader = () => {
        return (
            <>
                <h2>Facilities</h2>
                <ul className="header-tab-nav" role="navigation">
                    <li>
                       <Link to={() => formatRoute("/dashboard")}>
                           <button type="link" className={`${activeTab === "dashboard" ? "selected" : ""}`}>
                               Facilities Dashboard
                           </button>
                       </Link>
                    </li>
                    <li>
                        <Link to={() => formatRoute("")}>
                            <button type="link" className={`${activeTab === "list" ? "selected" : ""}`}>
                                Facility List
                            </button>
                        </Link>
                    </li>
                </ul>
            </>
        )
    }

    return <>{renderHeader()}</>
}
